import { of } from '@own-up/core-lib/optional';
import { createSelector, createStructuredSelector } from 'reselect';
import { ApplicationState } from '../../redux';
import { LockData } from '../../redux/lock-modal/state';
import { attorneyRequiredSelector } from './attorney-required-selector';
import { loanIdErrorSelector, loanIdSelector } from './loan-id-selector';

export const lockDataSelector = createSelector(
  ({ lockModal }: ApplicationState) => lockModal.modalLock,
  attorneyRequiredSelector,
  createStructuredSelector({
    value: loanIdSelector,
    error: loanIdErrorSelector
  }) as (state: ApplicationState) => { value: string; error: boolean },
  (modalLock, attorneyRequired, loanId) =>
    of(modalLock)
      .map((lockData: LockData) => {
        const { rgTitle, attorney, provider, notes, lockId, float } = lockData;
        return {
          loanId,
          attorney: {
            value: attorney,
            error: attorneyRequired ? !attorney : false
          },
          rgTitle: {
            value: rgTitle,
            error: rgTitle === undefined
          },
          provider,
          notes,
          lockId,
          float
        };
      })
      .orElse(() => ({
        loanId: { value: '', error: true },
        attorney: { value: undefined, error: true },
        rgTitle: { value: undefined, error: true },
        provider: undefined,
        notes: '',
        offerId: '',
        lockId: '',
        float: false
      }))
);
